<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="12px"
    viewBox="0 -960 960 960"
    width="12px"
    fill="currentColor"
  >
    <path
      d="M419.61-141v-234.87L215.54-257.93l-60.89-104.64L359.22-480 154.65-597.7l60.89-104.37 204.07 117.94V-819h120.78v234.87l204.07-117.94 60.89 104.37L600.78-480l204.57 117.43-60.89 104.64-204.07-117.94V-141H419.61Z"
    />
  </svg>
</template>
